import Login from './pages/Login'
import StoreLogin from './pages/StoreLogin'
import StoreRegistration from './pages/StoreRegistration'

import NewLogin from './pages_v2/Login'
import NewStoreLogin from './pages_v2/StoreLogin'
import NewStoreRegistration from './pages_v2/StoreRegistration'

export const getAuthPages = (uiVersion) => {
  if (uiVersion === 'new') {
    return {
      LoginPage: NewLogin,
      StoreLoginPage: NewStoreLogin,
      StoreRegistrationPage: NewStoreRegistration,
    }
  }

  return {
    LoginPage: Login,
    StoreLoginPage: StoreLogin,
    StoreRegistrationPage: StoreRegistration,
  }
}
